import { root, id } from './me';
import { permissions } from './permissions';

export const me = {
  ...root,
  id,
  permissions,
};
